import React, { useState, useContext  } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TextField, Button, Typography, Container, Box, Stack, Avatar, Chip, IconButton, InputAdornment } from '@mui/material';
import { useNavigate, Link } from 'react-router-dom';
import AuthContext from '../../contexts/AuthContext';
import { login } from '../../api';
import { setSnackDetails, setSuperUser } from '../../service/actions/common';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const Password = ({ switchToLogin }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [password, setPassword] = useState('');
    const username = useSelector((state) => state.username);
    const { login: setAuth } = useContext(AuthContext);
    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => setShowPassword(!showPassword);
    const handleMouseDownPassword = () => setShowPassword(!showPassword);

    const handleLoadPassword = async (e) => {
      e.preventDefault();
      if (password === '') {
        dispatch(setSnackDetails({openState : true, message : "*Please enter your password", severity : 'error'}));
        return;
      }
      // Here, add logic to authenticate with your API
      console.log('Login:', { username, password });
      try {
        const { data } = await login({ username, password });
        console.log(data);
        dispatch(setSnackDetails({openState : true, message : "Logged in successfully.", severity : 'success'}));
        setAuth(data.token);
        // set state for admin user
        dispatch(setSuperUser(data.user));
        // On successful login, navigate to the dashboard or another secured page
        navigate('/app-users');
      } catch (error) {
        dispatch(setSnackDetails({openState : true, message : error.response.data.message, severity : 'error'}));
        console.error(error);
      }
    };

  return (
    <Container maxWidth="xs">
      <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Avatar 
        alt="Logo" 
        src="logo.png" 
        variant="rounded" 
        sx={{
            height: 134,
            width: 134,
            maxHeight: { xs: 233, md: 167 },
            maxWidth: { xs: 350, md: 250 },
          }} />
       
        <Typography component="h1" variant="h5" sx={{ mt: 1 }}>
          Sign in
        </Typography>
        <Chip sx={{ mt: 1 }} label={username} variant="outlined" />
        <Box component="form" onSubmit={handleLoadPassword} sx={{ mt: 1, width: '100%' }}>
        <TextField
            margin="normal"
            fullWidth
            autoFocus
            name="confirmPassword"
            label="Password"
            type={showPassword ? "text" : "password"} // <-- This is where the magic happens
            id="confirmPassword"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <VpnKeyIcon />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />

          <Stack direction="row" justifyContent="center" sx={{ mt: 1 }}>
            <Button
                component="label"
                variant="text"
                onClick={switchToLogin}
              >
              Back
            </Button>
          </Stack>

          <Stack direction="row" justifyContent="space-between" spacing={2} sx={{ mt: 1 }}>
            <Button 
                component={Link} 
                to="/password-reset-request" 
                variant="text"
            >
                Reset Password
            </Button>
            <Button
              type="submit"
              variant="contained"
              sx={{ mt: 3, mb: 2, borderRadius: 28, ml: "auto" }}
            >
              Sign In
            </Button>
          </Stack>
        </Box>
      </Box>
    </Container>
  );
};

export default Password;